import type { FunctionComponentWithRef, ReactNode } from "react";

import { yieldToMain } from "shared/lib/utils";

import { CountMessage, Icon, StyledButton } from "./styles";

type Props = {
  className?: string;
  commentCount: number;
  icon?: ReactNode;
  onClick?: () => void;
};

export const ArticleCommentsButton: FunctionComponentWithRef<Props, HTMLButtonElement> = ({
  className,
  commentCount,
  icon,
  onClick,
  ref: forwardReference,
}) => {
  const hasComment = commentCount > 0;
  const commentCountDisplay = commentCount > 99 ? "99+" : commentCount;
  return (
    <StyledButton
      $hasComment={hasComment}
      className={className}
      onClick={() => {
        void (async () => {
          await yieldToMain({ priority: "user-blocking" });
          onClick?.();
        })();
      }}
      ref={forwardReference}
    >
      {hasComment && <CountMessage>{commentCountDisplay}</CountMessage>}
      {icon ?? <Icon />}
    </StyledButton>
  );
};

ArticleCommentsButton.displayName = "ArticleCommentsButton";
